module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('strong', [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/fm03"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/fm04"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_lev"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/fm04#fm04lev1"
    }
  }, [_vm._v("Mushrooms and Humans: Past, Present, and Future")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_lev"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/fm04#fm04lev2"
    }
  }, [_vm._v("A Bit about Me and My Approach to Mushroom Cultivation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch01"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "tcs"
  }, [_vm._v("1")]), _vm._v(" MUSHROOM BASICS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_lev"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch01#ch01lev1"
    }
  }, [_vm._v("What Are Mushrooms?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_lev"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch01#ch01lev2"
    }
  }, [_vm._v("Mushrooms in Ecosystems")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_lev"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch01#ch01lev3"
    }
  }, [_vm._v("What Mushrooms Need to Survive and Thrive")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch02",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "tcs"
  }, [_vm._v("2")]), _vm._v(" OVERVIEW OF THE CULTIVATION PROCESS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_lev"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch02#ch02lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cultivation Flow")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_lev"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch02#ch02lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preparation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "tcs"
  }, [_vm._v("3")]), _vm._v(" WORKSPACES, TOOLS, AND EQUIPMENT")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_lev"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch03#ch03lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lab Infrastructure and Aseptic Transfer Spaces: Flow Hoods, Still Air Boxes, and More")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_lev"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch03#ch03lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Lab Environment and Tools")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_lev"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch03#ch03lev3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Where to Inoculate Bulk Substrates")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_lev"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch03#ch03lev4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Where to Incubate Growing Mycelium")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_lev"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch03#ch03lev5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fruiting Space: Factors to Consider")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_lev"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch03#ch03lev6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Options for Home-Scale Fruiting Chambers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_lev"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch03#ch03lev7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Environmental Control in Fruiting Spaces")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_lev"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch03#ch03lev8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other Spaces")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "tcs"
  }, [_vm._v("4")]), _vm._v(" SANITATION AND TECHNIQUES TO AVOID CONTAMINATION")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_lev"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch04#ch04lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vectors of Contamination and Management Strategies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_lev"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch04#ch04lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Common Contaminants: Recognition and Management")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "tcs"
  }, [_vm._v("5")]), _vm._v(" STARTING AND MAINTAINING CULTURES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_lev"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch05#ch05lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Get Cultured")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_lev"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch05#ch05lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Liquid Culture")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_lev"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch05#ch05lev3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Agar Culture")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_lev"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch05#ch05lev4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Long-Term Culture Storage Methods")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "tcs"
  }, [_vm._v("6")]), _vm._v(" MAKING AND USING GRAIN SPAWN")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_lev"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch06#ch06lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Making Grain Spawn")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_lev"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch06#ch06lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Using Grain Spawn")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/ch07",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "tcs"
  }, [_vm._v("7")]), _vm._v(" FRUITING SUBSTRATE FORMULATION AND PREPARATION")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_lev"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch07#ch07lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Containers for Mycelial Growth and Fruiting")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_lev"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch07#ch07lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Substrates")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_lev1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch07#ch07lev3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Substrate Treatments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_lev1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch07#ch07lev4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sterilization")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_lev1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch07#ch07lev5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pasteurization and Alternatives")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch08",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "tcs"
  }, [_vm._v("8")]), _vm._v(" OUTDOOR GROWING AND MUSHROOM GARDENING")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_lev"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch08#ch08lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Growing Mushrooms on Logs and Stumps")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_lev"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch08#ch08lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mushroom Beds")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_lev"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch08#ch08lev3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Next-Level Applications")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch09",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "tcs"
  }, [_vm._v("9")]), _vm._v(" HARVEST, PROCESSING, AND USE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_lev"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch09#ch09lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("When and How to Harvest")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_lev"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch09#ch09lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Basic Cooking Techniques")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_lev"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch09#ch09lev3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preservation Methods")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_lev"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch09#ch09lev4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mushrooms and Mycelium for Medicine")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/bm02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IN CONCLUSION: SUBSTRATE FOR THOUGHT—TOWARD FURTHER APPLICATIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_lev"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/bm02#bm02lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mycopermaculture")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_lev"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/bm02#bm02lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mycoremediation on a Home Scale")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_lev"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/bm02#bm02lev3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mycoarts and Fungi as Functional Materials")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_lev"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/bm02#bm02lev4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Community-Based Cultivation Efforts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/app01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX 1: SPECIES PROFILES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_lev"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/app01#app01lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Agrocybe aegerita")]), _vm._v("—Pioppino")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_lev"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/app01#app01lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Coprinus comatus")]), _vm._v("—Shaggy Mane")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_lev"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/app01#app01lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Cordyceps militaris")]), _vm._v("—Caterpillar Fungus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_lev"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/app01#app01lev4",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Flammulina velutipes")]), _vm._v(" and allies—Enoki")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_lev"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/app01#app01lev5",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Ganoderma lucidum")]), _vm._v(" and allies—Reishi")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_lev"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/app01#app01lev6",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Hericium")]), _vm._v(" species—Lion’s Mane and allies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_lev"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/app01#app01lev7",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Hypsizygus tessulatus")]), _vm._v("—Shimeji and "), _c('em', [_vm._v("H. ulmarius")]), _vm._v("—Elm Oysters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_lev"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/app01#app01lev8",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Lentinula edodes")]), _vm._v("—Shiitake")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_lev"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/app01#app01lev9",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Pholiota nameko")]), _vm._v(" and allies—Nameko")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_lev"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/app01#app01lev10",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Pleurotus")]), _vm._v(" species—Oyster Mushrooms")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_lev"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/app01#app01lev11",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Stropharia rugoso-annulata")]), _vm._v("—Wine Cap")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_lev"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/app01#app01lev12",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Trametes versicolor")]), _vm._v("—Turkey Tail")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/app02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX 2: RESOURCES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_lev"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/app02#app02lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("General")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_lev"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/app02#app02lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Annual Mycology Gatherings")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/bm03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BIBLIOGRAPHY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/bm04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INDEX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/bm05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ABOUT THE AUTHOR AND ILLUSTRATOR")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/bm06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A NOTE ABOUT THE PUBLISHER")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78ee341a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/contents.vue
// module id = 69
// module chunks = 0